import { RicoPunt, RicoTweePunten } from "../../../../content/wiskunde/1g_fx/voorschrift_opstellen/exercises";
import * as React from 'react';
export default {
  RicoPunt,
  RicoTweePunten,
  React
};